<template>
<!-- contents -->
<div id="contents">
    <div class="contents_wrap">
        <!-- contents_head -->
        <!-- breadcrumbs -->
        <skp-breadcrumbs @page-title="val => pageTitle = val" />
        <!-- //breadcrumbs -->
        <h2 class="pg_title">{{ pageTitle }}</h2>
        <!-- //contents_head -->

        <!-- srchTop_wrap -->
        <div class="srchTop_wrap">
            <article class="srch_basic">
                <div class="srch_grup">
                    <ul class="w50">
                        <li class="tit_150">{{ $t('FIELD.GLOBAL.SUBSIDIARY') }}</li>
                        <li data-input-type="select" class="w100-150">
                            <fieldset class="ui_fieldset set_2">
                                <div>
                                    <select id="strRhqcd" name="strRhqcd" v-model="strRhqcd" @change="changeRhqCd($event)" class="slt_white w100">
                                        <option value="" v-if="isAllUser()" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                        <option value="" v-else disabled>{{ $t('FIELD.GLOBAL.SELECT') }}</option>
                                        <option v-for="(item, index) in rhqCdList" :key="item.code" :value="item.code">{{item.codeName}}</option>
                                    </select>
                                </div>
                                <div>
                                    <select id="loginCorp" name="loginCorp" v-model="loginCorp" @change="changeCorpCd($event)" class="slt_white w100">
                                        <option value="" v-if="isAllUser()" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                        <option value="" v-else disabled>{{ $t('FIELD.GLOBAL.SELECT') }}</option>
                                        <option v-for="(item, index) in rhqSubCdList" :key="item.code" :value="item.code" >{{item.codeName}}</option>
                                    </select>
                                </div>
                            </fieldset>
                        </li>
                    </ul>
                    <ul class="w50">
                        <li class="tit_150">{{ $t('FIELD.GLOBAL.REGISTER') }}</li>
                        <li data-input-type="input" class="w100-150">
                            <label class="serach-wrap">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    v-model="searchUserNm"
                                    :placeholder="$t('FIELD.GLOBAL.SEARCH')"
                                    :disabled="true"
                                    @click="searchUserPop"
                                />
                                <a href="javascript:" class="in_btn_search" @click="searchUserPop">
                                    <i class="ico_input_serach"></i>
                                </a>
                            </label>
                        </li>
                    </ul>
                    <ul class="w50">
                        <li class="tit_150">{{ $t('FIELD.GLOBAL.MENU') }}</li>
                        <li data-input-type="select" class="w100-150">
                            <fieldset class="ui_fieldset set_2">
                                <div>
                                    <select
                                        id="BOARD_TYPE1"
                                        name="BOARD_TYPE1"
                                        v-model="BOARD_TYPE1"
                                        class="slt_white w100"
                                        @change="changeBoardType1($event)"
                                    >
                                        <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                        <option v-show="boardType1List.length > 0"
                                                v-for="item in boardType1List"
                                                :key="item.code"
                                                :value="item.code"
                                        >{{item.codeName}}</option>
                                    </select>
                                </div>
                                <div>
                                    <select
                                        id="BOARD_TYPE2"
                                        name="BOARD_TYPE2"
                                        v-model="BOARD_TYPE2"
                                        class="slt_white w100"
                                    >
                                        <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                        <option v-show="boardType2List.length > 0"
                                                v-for="item in boardType2List"
                                                :key="item.code"
                                                :value="item.code"
                                                :data-menu-grp-dtl-cd="item.menuGrpDtlCd"
                                        >{{item.codeName}}</option>
                                    </select>
                                </div>
                            </fieldset>
                        </li>
                    </ul>
                    <ul class="w50">
                        <li class="tit_150">{{ $t('FIELD.GLOBAL.DATE') }}</li>
                        <li data-input-type="date" class="w100-150">
                            <fieldset class="ui_fieldset">
                                <label class="date-wrap">
                                    <input id="fromDate" type="text" class="date_input w100p" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                                    <a href="javascript:" class="in_btn" id="icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                </label>
                                <div id="from-picker-container" style="margin-top: -1px;"/>
                                <em class="txt_space"></em>
                                <label class="date-wrap">
                                    <input id="toDate" type="text" class="date_input w100p" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                                    <a href="javascript:" class="in_btn" id="icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                </label>
                                <div id="to-picker-container" style="margin-top: -1px;"/>
                            </fieldset>
                        </li>
                    </ul>
                    <ul class="w50">
                        <li class="tit_150">{{ $t('FIELD.GLOBAL.BOARD.NAME') }}</li>
                        <li data-input-type="input" class="w100-150">
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    maxlength="100"
                                    :placeholder="$t('FIELD.GLOBAL.BOARD.NAME')"
                                    v-model="searchName"
                                    v-clearable
                                />
                            </span>
                        </li>
                    </ul>
                    <ul class="w50">
                        <li class="tit_150">{{ $t('FIELD.GLOBAL.STATUS') }}</li>
                        <li data-input-type="select" class="w100-150">
                            <select class="slt_white w100p"
                                    id="Status"
                                    v-model="Status"
                            >
                                <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-show="statusComboList.length > 0"
                                        v-for="item in statusComboList"
                                        :key="item.code"
                                        :value="item.code"
                                >{{item.codeName}}</option>
                            </select>
                        </li>
                    </ul>
                </div>
                <div class="srch_grupR">
                    <span class="btn">
                        <a href="javascript:" class="btn_srch" @click="handleSearch">{{ $t('FIELD.GLOBAL.SEARCH') }}</a>
                    </span>
                </div>
            </article>
        </div>

        <!-- Grid -->
        <div class="grid_wrap" v-if="!isLoading" v-resize="setGridResizeColumn">
            <!-- Count -->
            <div class="grid_total">Total Count <em>{{ totalCount | numberFormat }}</em></div>
            <div v-if="params.creationYn === 'Y'" class="btn_wrap">
                <a href="javascript:" class="btn_gray" @click="btnCreate">{{ $t('BUTTON.GLOBAL.CREATE') }}</a>
            </div>
            <board-grid
                :gridId="gridId"
                :ref="gridId"
                :columns="columns"
                :data="gridData"
                :options="options"
                :pageOptions="pageOptions"
                :isTotalCount="false"
                :click="contentClick"
                @grid-total-count="setTotalCount"
            />
            <div class="paginate">
                <sdl-pagination
                    align="center"
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    @change="movePage"
                />
            </div>
        </div>
    </div>
</div>
<!-- contents -->
</template>
<script>
import Vue                                  from 'vue';
import axios                                from 'axios';
import qs                                   from 'query-string';
import { mapGetters, mapActions }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import resize                               from 'vue-resize-directive'
import moment                               from 'moment';
import api                                  from '@/service';
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import SDLPagination                        from '~~c/control/pagination/Pagination';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import DatePicker                           from '~c/DatePicker';

import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';
import BoardManageListGrid                  from './BoardManageListGrid';

import SearchUserPopup                      from '~va/qnaManager/popup/searchUserPop';

require('moment-jdateformatparser');

const MAX_DATE = new Date(2999,12,31),
      MIN_DATE = new Date(1900,1,1);

export default {
    name: 'BoardManageList',
    data() {
        return {
            isLoading: true,
            pageTitle: '',

            strRhqcd: '',
            loginCorp: '',

            rhqCdList: [],
            rhqSubCdList: [],

            BOARD_TYPE1: '',            // board Type - board parent id
            BOARD_TYPE2: '',            // board Type - board id
            boardType1List: [],         // board Type List 1
            boardType2List: [],         // board Type List 2
            searchUserNm: '',           // Search User

            rangePicker: null,

            Status: '',                 // Status
            statusComboList: [],        // Status List
            searchName: '',             // Name

            gridId: 'boardManageGrid',
            columns: [],
            options: {},
            pageOptions: {},
            gridData: [],

            totalCount: 0,
            pageNo: 1,
            currentPage: 1,
            perPage: localStorage.getItem('listRows') ? Number(localStorage.getItem('listRows')) : 10
        }
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            loginRhq: 'getLoginRhq',
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            params: 'getParams',
            locale: 'getLocale',
            menus: 'getMenus',
        }),
        getLoginNo()            { return this.loginNo || ''; },
        getUserRole()           { return this.userRoles || []; },
        getUserCorpCd()         { return this.userCorpCd || ''; },
        getLoginRHQCd()         { return this.loginRhq || ''; },
        getSelLoginCorp()       { return this.loginCorp || ''; },
        getSelBoardType1()      { return this.BOARD_TYPE1 || ''; },
        getSelBoardType2()      { return this.BOARD_TYPE2 || ''; },
        getPageNo()             { return this.pageNo; },

    },
    directives: { resize },
    components: {
        'skp-breadcrumbs'   : SKPBreadcrumbs,
        'sdl-pagination'    : SDLPagination,
        'board-grid'        : BoardManageListGrid,
    },
    methods: {
        // 처음 로딩 시
        initLoad() {
            SDLUtil.showLoadingBar(true);
            // 그리드 컬럼 세팅
            this.columns = this.getDynamicCols();
            // RHQ
            this.setRhqCd();
            // 게시판 타입 1 로드
            this.setBoardType1();
            // 초기 상태 리스트 로드
            this.setStatusList();

            this.isLoading = false;
            // 조회 완료 후
            SDLUtil.showLoadingBar(false);

            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(this.isLoading); }, 1000 );
            });
        },
        setRhqCd() {
            let that = this;
            this.getCodeComboList(this.loginNo, "RHQ_AUTH_ACCESS_CD")
                .then(data => {
                    this.rhqCdList = data, this.strRhqcd = this.getLoginRHQCd;
                    this.rhqSubCdList = [], this.loginCorp = '';

                    setTimeout( () => {
                        this.getCodeComboList(this.strRhqcd, "SUB_AUTH_ACCESS_CD")
                            .then(data => {
                                that.rhqSubCdList = data;
                                that.loginCorp = that.getUserCorpCd;
                            });
                    }, 100 );
                });
        },
        // 지역 코드 변경 이벤트
        changeRhqCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue === "") {
                this.rhqSubCdList   = [], this.loginCorp   = '';
                this.boardType1List = [], this.BOARD_TYPE1 = '';
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else {
                this.getCodeComboList(comboValue, "SUB_AUTH_ACCESS_CD").then(data => {
                    this.rhqSubCdList   = data, this.loginCorp   = '';
                    this.boardType1List = [],   this.BOARD_TYPE1 = '';
                    this.boardType2List = [],   this.BOARD_TYPE2 = '';
                });
            }
        },
        // 법인 코드 변경 이벤트
        changeCorpCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue === "") {
                this.boardType1List = [], this.BOARD_TYPE1 = '';
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else {
                this.getCodeComboList(comboValue, "BOARD_TYPE1").then(data => {
                    this.boardType1List = data, this.BOARD_TYPE1 = '';
                    this.boardType2List = [],   this.BOARD_TYPE2 = '';
                });
            }
        },
        // Code combo list api
        async getCodeComboList(categoryVal, categoryCode) {
            let corpCd = ['BOARD_TYPE1', 'BOARD_TYPE2'].includes(categoryCode) ? this.loginCorp : this.getUserCorpCd;
            let additionalValue = (['RHQ_AUTH_ACCESS_CD', 'SUB_AUTH_ACCESS_CD'].includes(categoryCode)) ? this.getLoginNo : corpCd;
            const codeResp = await api.getComboList(categoryVal, categoryCode, additionalValue);
            return codeResp;
        },
        getComboBoxVal(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).value : "";
        },
        getComboBoxName(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).name : "";
        },
        // Board1 setting
        setBoardType1() {
            this.getCodeComboList(this.getUserCorpCd, "BOARD_TYPE1").then(data => {
                this.BOARD_TYPE1 = this.getSelBoardType1;
                this.boardType1List = data;
            });
        },
        // Board1 combo change event => create Board2 combo list
        changeBoardType1(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else {
                this.getCodeComboList(comboValue, "BOARD_TYPE2").then(data => {
                    this.boardType2List = data;
                    this.BOARD_TYPE2 = '';
                });
            }
        },
        // Status Combo list
        setStatusList() {
            SDLUtil.getCommCodeList('BOARD_STATUS').then(data => {
                this.Status = '';
                this.statusComboList = data;
            });
        },
        
        // 권한체크
        isAllUser(){
            if(
                this.getUserRole.includes(`${constants.SYSTEM_ADMIN}`)
             || this.getUserRole.includes(`${constants.GBM_ADMIN}`)
             || this.getUserRole.includes(`${constants.RHQ_ADMIN}`)
            ) {
                return true;
            } else {
                return false;
            };
        },

        // 그리드 컬럼 percent resize 용
        getDynamicCols() {
            return [
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBSIDIARY'), name: 'CORP_NM', align: 'center', width: this.getColumnSize(10), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY'), name: 'BOARD_TYPE_NM', align: 'center', width: this.getColumnSize(20), resizable: true, sortable: false },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.BOARD.NAME'), name: 'BOARD_NM', align: 'center', width: this.getColumnSize(20), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.STATUS'), name: 'STATUS_NM', align: 'center', width: this.getColumnSize(15), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.CREATED.BY'), name: 'LOGIN_NAME', align: 'center', width: this.getColumnSize(15), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.DATE'), name: 'REG_DT', align: 'center', width: this.getColumnSize(10), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.ROWS'), name: 'CNT_CHAR', align: 'center', width: this.getColumnSize(10), resizable: true, sortable: false },
                { header: 'CORP_NO', name: 'CORP_NO', hidden: true },
                { header: 'STATUS', name: 'STATUS', hidden: true },
                { header: 'REG_USER_NO', name: 'REG_USER_NO', hidden: true },
            ];
        },
        getColumnSize(size) {
            if(isNaN(Number(size))) { return 0; }
            let gridWrapSize = document.getElementsByClassName('grid_wrap').length ? document.getElementsByClassName('grid_wrap')[0].clientWidth - 16 : 1000;
            return Math.floor((gridWrapSize) / (100 / size));
        },
        setGridResizeColumn(e) {
            EventBus.$emit('board-grid-set-column', this.getDynamicCols());
        },
        // 그리드 컬럼 percent resize 용

        searchUserPop() {
            SDLUtil.show(
                SearchUserPopup,
                {
                    rtnFunc: (loginNo, loginId, loginNm) => {
                        this.searchUserNm = loginNm;
                    },
                },
                { width: '500px', height: 'auto' },
            );
        },

        // 페이지 이동
        movePage(pageNo) {
            this.currentPage = pageNo;
            this.handlePageSearch(pageNo);
        },
        // 총 합계 설정
        setTotalCount(totCnt)   { this.totalCount = totCnt; },
        // 현재 페이지 설정
        setCurrentPage(page)    { this.currentPage = page; },
        // 컨텐츠 클릭 이벤트
        contentClick(e, rowData, grid) {
            let colNm = e.columnName;
            if ((typeof e.rowKey) === "undefined") return;
            let row = rowData.find(function(r){ return r.rowKey === e.rowKey });
            let boardId = row['BOARD_ID'] || '';
            Vue.$log.info('▶ BoardManageList.vue contentClick event. =>', row, boardId);
            
            if(boardId !== null) {
                window.scrollTo(0, 0);
                return this.$router.push({ name: 'BoardManageDetail', query: { BOARD_ID: boardId } });
            };
        },
        // 정렬 조회 - 정렬로 조회하는 경우, 페이지를 1로 초기화 한다.
        handleSortSearch(sortObj) {
            if(!SDLUtil.isNull(sortObj.orderColName)) {
                this.ORDER_COLUMN = sortObj.orderColName;
                this.ORDER_ASC = sortObj.ascending ? "ASC" : "DESC";
            } else {
                this.ORDER_COLUMN = '';
                this.ORDER_ASC = '';
            }

            this.handlePageSearch(1);
        },
        // 페이지 조회
        handlePageSearch(pageNo) {
            if(pageNo !== null && pageNo != "") {
                this.pageNo = pageNo;
                this.knowledgeList = [];
                this.handleSearch();

            } else {
                Vue.$log.warn('Page no is null');
            }
        },
        // 검색 파라미터 설정
        setSearchParameter() {
            let mFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            let params = {
                searchCorp: this.getSelLoginCorp,
                BOARD_TYPE1: this.getSelBoardType1,
                BOARD_TYPE2: this.getSelBoardType2,
                searchUserNo: this.searchUserNo,
                searchName: this.searchName,
                Status: this.Status,

                searchFromAddDt: this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).formatWithJDF(mFormat) : '',
                searchToAddDt: this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).formatWithJDF(mFormat) : '',
                ORDER_COLUMN: this.ORDER_COLUMN || '',
                ORDER_ASC: this.ORDER_ASC || '',
                page: this.getPageNo
            };

            return params;
        },
        // 조회
        handleSearch() {
            // Call ExpiredKnowledgeListGrid.vue > loadData method
            EventBus.$emit('board-grid-search', this.setSearchParameter());
        },
        // 재조회
        reSearch(pageNo) {
            // this.setCategoryParam(boardParam.searchParams);
            this.pageNo = pageNo;
            this.handlePageSearch(pageNo);
        },
        btnCreate() {
            ///basis/admin/knowledgeManager/boardManage/boardManageRegister.skp
            this.$router.push({ name: 'BoardManageRegister' });
        }
    },
    created(){
        Vue.$log.info('▶ BoardManageList.vue created.');
        EventBus.$on('board-page-search', pageNo    => { this.handlePageSearch(pageNo); });
        EventBus.$on('board-sort-search', sortForm  => { this.handleSortSearch(sortForm); });

    },
    mounted(){
        // DOM 생성 후 이벤트
        this.$nextTick(() => {
            // 범위 지정 Datepicker 로 변경
            this.rangePicker = DatePicker.createRangeWithOpener(
                'from-picker-container', 'fromDate', 'icoFromDate',
                'to-picker-container', 'toDate', 'icoToDate',
                { type: 'date', locale: 'en', showToday: false }
            );

            this.initLoad().then(isLoading => {
                if(!isLoading) {
                    //
                }
            });

        });
    },
    beforeDestroy(){
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('board-page-search');
        EventBus.$off('board-sort-search');
    }
};
</script>

<style>
.zindex9999 { z-index: 9999; }
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/knowledgeManager/boardManage/BoardManageList.vue